module.exports = __webpack_public_path__ + "img/iconLogout.0d7f0030.svg";